/**
 * @generated SignedSource<<a265eb021a2f133bbc406ff14db36f91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BlogSubcategory_Query$variables = {
  subcategory: string;
};
export type BlogSubcategory_Query$data = {
  readonly blogSubcategory: {
    readonly __typename: "BlogSubcategory";
  } | null | undefined;
  readonly currentUser: {
    readonly " $fragmentSpreads": FragmentRefs<"BlogSubcategory_User" | "auth_checkAuthForPage">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"BlogSubcategoryLanding_Query" | "BlogSubcategorySignedIn_Query">;
};
export type BlogSubcategory_Query = {
  response: BlogSubcategory_Query$data;
  variables: BlogSubcategory_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "subcategory"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unconfirmedEmail",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "confirmedEmail",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "integrationName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "passwordSetupRequired",
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "filters",
    "value": {
      "statuses": [
        "active",
        "paused"
      ]
    }
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enableTimesheets",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowExpensesAccess",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentsEnabled",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v11 = {
  "kind": "Literal",
  "name": "first",
  "value": 0
},
v12 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
],
v13 = {
  "alias": "offers",
  "args": [
    {
      "kind": "Literal",
      "name": "filters",
      "value": {
        "statuses": [
          "offer_made"
        ]
      }
    },
    (v11/*: any*/)
  ],
  "concreteType": "ContractConnection",
  "kind": "LinkedField",
  "name": "freelancerContracts",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": "freelancerContracts(filters:{\"statuses\":[\"offer_made\"]},first:0)"
},
v14 = {
  "alias": "interviews",
  "args": [
    {
      "kind": "Literal",
      "name": "filters",
      "value": {
        "stage": "interview"
      }
    },
    (v11/*: any*/)
  ],
  "concreteType": "JobApplicationConnection",
  "kind": "LinkedField",
  "name": "freelancerJobApplications",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": "freelancerJobApplications(filters:{\"stage\":\"interview\"},first:0)"
},
v15 = {
  "alias": "screening",
  "args": [
    {
      "kind": "Literal",
      "name": "filters",
      "value": {
        "withJobScreening": true
      }
    },
    (v11/*: any*/)
  ],
  "concreteType": "JobApplicationConnection",
  "kind": "LinkedField",
  "name": "freelancerJobApplications",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": "freelancerJobApplications(filters:{\"withJobScreening\":true},first:0)"
},
v16 = {
  "alias": "applications",
  "args": [
    {
      "kind": "Literal",
      "name": "filters",
      "value": {
        "statuses": [
          "job_application_sent",
          "job_application_draft"
        ]
      }
    },
    (v11/*: any*/)
  ],
  "concreteType": "JobApplicationConnection",
  "kind": "LinkedField",
  "name": "freelancerJobApplications",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": "freelancerJobApplications(filters:{\"statuses\":[\"job_application_sent\",\"job_application_draft\"]},first:0)"
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMember",
  "storageKey": null
},
v18 = {
  "kind": "InlineDataFragmentSpread",
  "name": "user_isMember",
  "selections": [
    (v1/*: any*/),
    (v17/*: any*/)
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isClient",
  "storageKey": null
},
v20 = {
  "kind": "InlineDataFragmentSpread",
  "name": "user_isClient",
  "selections": [
    (v1/*: any*/),
    (v19/*: any*/)
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guest",
  "storageKey": null
},
v22 = {
  "kind": "InlineDataFragmentSpread",
  "name": "user_isGuest",
  "selections": [
    (v21/*: any*/),
    (v1/*: any*/)
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v23 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "subcategory"
  }
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v25 = [
  {
    "kind": "Variable",
    "name": "subcategory",
    "variableName": "subcategory"
  }
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v27 = [
  (v10/*: any*/),
  (v26/*: any*/)
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v29 = [
  (v28/*: any*/),
  (v10/*: any*/),
  (v26/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BlogSubcategory_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BlogSubcategory_User"
          },
          {
            "kind": "InlineDataFragmentSpread",
            "name": "auth_checkAuthForPage",
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "auth_getRedirectPath",
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "auth_getDefaultPath",
                    "selections": [
                      (v3/*: any*/),
                      (v5/*: any*/),
                      (v1/*: any*/),
                      {
                        "alias": "activeContracts",
                        "args": (v6/*: any*/),
                        "concreteType": "ContractConnection",
                        "kind": "LinkedField",
                        "name": "freelancerContracts",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Contract",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Firm",
                                "kind": "LinkedField",
                                "name": "firm",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "freelancerContracts(filters:{\"statuses\":[\"active\",\"paused\"]},first:1)"
                      },
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v18/*: any*/),
                      (v20/*: any*/),
                      (v22/*: any*/)
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  },
                  (v22/*: any*/),
                  (v18/*: any*/),
                  (v20/*: any*/)
                ],
                "args": null,
                "argumentDefinitions": []
              }
            ],
            "args": null,
            "argumentDefinitions": []
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v23/*: any*/),
        "concreteType": "BlogSubcategory",
        "kind": "LinkedField",
        "name": "blogSubcategory",
        "plural": false,
        "selections": [
          (v24/*: any*/)
        ],
        "storageKey": null
      },
      {
        "args": (v25/*: any*/),
        "kind": "FragmentSpread",
        "name": "BlogSubcategoryLanding_Query"
      },
      {
        "args": (v25/*: any*/),
        "kind": "FragmentSpread",
        "name": "BlogSubcategorySignedIn_Query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BlogSubcategory_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v21/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": "activeContracts",
            "args": (v6/*: any*/),
            "concreteType": "ContractConnection",
            "kind": "LinkedField",
            "name": "freelancerContracts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Contract",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Firm",
                    "kind": "LinkedField",
                    "name": "firm",
                    "plural": false,
                    "selections": (v27/*: any*/),
                    "storageKey": null
                  },
                  (v26/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "freelancerContracts(filters:{\"statuses\":[\"active\",\"paused\"]},first:1)"
          },
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v19/*: any*/),
          (v26/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v23/*: any*/),
        "concreteType": "BlogSubcategory",
        "kind": "LinkedField",
        "name": "blogSubcategory",
        "plural": false,
        "selections": [
          (v24/*: any*/),
          (v26/*: any*/),
          (v28/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "heroImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BlogCategory",
            "kind": "LinkedField",
            "name": "blogCategory",
            "plural": false,
            "selections": (v29/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "last",
            "value": 20
          },
          {
            "kind": "Variable",
            "name": "subcategorySlug",
            "variableName": "subcategory"
          }
        ],
        "concreteType": "BlogPostConnection",
        "kind": "LinkedField",
        "name": "blogPosts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BlogPost",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v26/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "excerpt",
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BlogCategory",
                "kind": "LinkedField",
                "name": "blogCategories",
                "plural": true,
                "selections": (v29/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "estimatedReadingTimeMinutes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewsCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v28/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": (v27/*: any*/),
                    "storageKey": null
                  },
                  (v26/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "76c8f308253ddf1118e2b63723c93e63",
    "id": null,
    "metadata": {},
    "name": "BlogSubcategory_Query",
    "operationKind": "query",
    "text": "query BlogSubcategory_Query(\n  $subcategory: String!\n) {\n  currentUser {\n    ...BlogSubcategory_User\n    ...auth_checkAuthForPage\n    id\n  }\n  blogSubcategory(slug: $subcategory) {\n    __typename\n    id\n  }\n  ...BlogSubcategoryLanding_Query_2OOqcL\n  ...BlogSubcategorySignedIn_Query_2OOqcL\n}\n\nfragment BlogPostItem_BlogPost on BlogPost {\n  title\n  excerpt\n  slug\n  blogCategories {\n    name\n    slug\n    id\n  }\n  createdAt\n  estimatedReadingTimeMinutes\n  viewsCount\n  user {\n    name\n    profile {\n      slug\n      id\n    }\n    ...UserAvatarContainer_User\n    id\n  }\n}\n\nfragment BlogSubcategoryLanding_Query_2OOqcL on Query {\n  blogPosts(last: 20, subcategorySlug: $subcategory) {\n    nodes {\n      id\n      ...BlogPostItem_BlogPost\n    }\n  }\n  blogSubcategory(slug: $subcategory) {\n    name\n    slug\n    description\n    heroImageUrl\n    blogCategory {\n      name\n      slug\n      id\n    }\n    id\n  }\n}\n\nfragment BlogSubcategorySignedIn_Query_2OOqcL on Query {\n  blogPosts(last: 20, subcategorySlug: $subcategory) {\n    nodes {\n      id\n      ...BlogPostItem_BlogPost\n    }\n  }\n  blogSubcategory(slug: $subcategory) {\n    name\n    slug\n    description\n    heroImageUrl\n    blogCategory {\n      name\n      slug\n      id\n    }\n    id\n  }\n}\n\nfragment BlogSubcategory_User on User {\n  ...user_useIsGuest\n}\n\nfragment UserAvatarContainer_User on User {\n  id\n}\n\nfragment auth_checkAuthForPage on User {\n  ...auth_getRedirectPath\n}\n\nfragment auth_getDefaultPath on User {\n  confirmedEmail\n  passwordSetupRequired\n  status\n  activeContracts: freelancerContracts(first: 1, filters: {statuses: [active, paused]}) {\n    nodes {\n      enableTimesheets\n      allowExpensesAccess\n      paymentsEnabled\n      firm {\n        slug\n        id\n      }\n      id\n    }\n  }\n  offers: freelancerContracts(first: 0, filters: {statuses: [offer_made]}) {\n    totalCount\n  }\n  interviews: freelancerJobApplications(first: 0, filters: {stage: interview}) {\n    totalCount\n  }\n  screening: freelancerJobApplications(first: 0, filters: {withJobScreening: true}) {\n    totalCount\n  }\n  applications: freelancerJobApplications(first: 0, filters: {statuses: [job_application_sent, job_application_draft]}) {\n    totalCount\n  }\n  ...user_isMember\n  ...user_isClient\n  ...user_isGuest\n}\n\nfragment auth_getRedirectPath on User {\n  status\n  unconfirmedEmail\n  confirmedEmail\n  integrationName\n  ...auth_getDefaultPath\n  ...user_isGuest\n  ...user_isMember\n  ...user_isClient\n}\n\nfragment user_isClient on User {\n  status\n  isClient\n}\n\nfragment user_isGuest on User {\n  guest\n  status\n}\n\nfragment user_isMember on User {\n  status\n  isMember\n}\n\nfragment user_useIsGuest on User {\n  ...user_isGuest\n}\n"
  }
};
})();

(node as any).hash = "e92428221b4aaba3335148fdecc2f972";

export default node;
